<template>
	<el-dialog title="编辑维修记录" v-model="isEditRecord" width="60%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">基础信息</p> -->
			<div class="info-input-container">
				<div class="flex flex-y-start flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>车牌号码</span>
						</div>
						<el-input v-model="verrVehNo" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
					
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修标题</span>
						</div>
						<el-input v-model="verrTitle" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="verrTime" type="datetime" :clearable="false" placeholder="请选择日期"
								@change="getverrTime">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修费用</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="verrMoney" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修经办人</span>
						</div>
						<el-input v-model="verrHandler" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付状态</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="verrPayStatus" placeholder="请选择支付状态">
								<el-option label="未支付" value="0" />
								<el-option label="已支付" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="verrPayDate" type="datetime" :clearable="false" placeholder="请选择日期"
								@change="getverrPayDate">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付账户</span>
						</div>
						<el-input v-model="verrPayAccount" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修状态</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="verrStatus" placeholder="请选择维修状态">
								<el-option label="维修中" value="0" />
								<el-option label="维修完成" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>维修描述</span>
						</div>
						<el-input v-model="verrDescribe" type="textarea" class="platItemRigth2" placeholder="请输入"
							:rows="5" />
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>维修凭证</span>
						</div>
						<div class="rpic_img_box">
							<template v-if="proofPicList.length > 0">
								<div class="upRpic_icon_item" v-for="(item, index) in proofPicList" :key="index">
									<img :src="item" alt="" style="width: auto; height: 60%" v-viewer/>
									<div class="image-box-item-del" @click="delImg(index)">
										<img src="@/assets/images/handle/del-icon.png" alt="" />
									</div>
								</div>
							</template>

							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadproofPicList" accept=".jpg,.jpeg,.png" v-if="proofPicList.length < 6">
								<div class="upRpic_icon_item">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>
				</div>
			</div>




			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>
			<!-- 
			<Address ref="addressRef" v-if="isAddress" @getAddressData="getAddressData" /> -->
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Address from "./address";
	export default defineComponent({
		components: {
			// Address
		},
		name: "Add",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};

			onMounted(() => {
				nextTick(() => {
					getVehHeadList(); //获取车辆
				});
			});
			const data = reactive({
				isEditRecord: false,
				vehHeadList: [],
				rpicUrl: [], //生活照片
				isAddress: false,
				addType: "",
				isVehIdReadOnly: false,

				verrId: "",
				verrVehId: "", //车辆信息表ID，外键
				verrVehNo: "",
				verrType: "", //类型：0维修1出险
				verrTime: "", //维修时间
				verrTitle: "", //标题
				verrMoney: "", //总金额
				verrHandler: "", //经办人
				verrDescribe: "", //维修描述
				verrRemark: "", //备注
				verrStatus: 0, //0未解决1已解决2跟进中
				proofPicList: [], //凭证图片
				verrPayStatus: 0, //支付状态：0未支付1已支付
				verrPayDate: "", //支付日期
				verrPayAccount: "", //支付账户
				veriType: "", //项目类型：0轮胎1机油2变速箱油
				veriName: "", //项目名称
				veriBrand: "", //品牌
				veriSpecifications: "", //规格
				veriPrice: "", //项目单价
				veriCount: "", //数量
				veriPriceSum: "", //项目总价
				veriRemark: "", //审核附言

			});
			//重置数据
			const init = (id) => {
				data.isEditRecord = true;
				data.addType = "";
				//data.vehHeadList = [];

				data.verrId = id;
				data.verrVehId = "";
				data.verrVehNo = "";
				data.verrType = "";
				data.verrTime = "";
				data.verrTitle = "";
				data.verrMoney = "";
				data.verrHandler = "";
				data.verrDescribe = "";
				data.verrRemark = "";
				data.verrStatus = 0;
				data.proofPicList = [];
				data.verrPayStatus = 0;
				data.verrPayDate = "";
				data.verrPayAccount = "";
				data.veriType = "";
				data.veriName = "";
				data.veriBrand = "";
				data.veriSpecifications = "";
				data.veriPrice = "";
				data.veriCount = "";
				data.veriPriceSum = "";
				data.veriRemark = "";

				getRecordData();

			};

			//获取列表数据
			const getRecordData = async () => {
				let params = {
					verrId: data.verrId,
				};
				const r = await proxy.$http.get(apiObj.vehRepairRecedit, params);
				if (r.code === 0 || r.respCode === '0000') {
					data.verrVehId = r.vehRepairRec.verrVehId;
					data.verrVehNo = r.vehRepairRec.vehNo;
					data.verrType = r.vehRepairRec.verrType;
					data.verrTime = r.vehRepairRec.verrTime;
					data.verrTitle = r.vehRepairRec.verrTitle;
					data.verrMoney = r.vehRepairRec.verrMoney;
					data.verrHandler = r.vehRepairRec.verrHandler;
					data.verrDescribe = r.vehRepairRec.verrDescribe;
					data.verrRemark = r.vehRepairRec.verrRemark;
					data.proofPicList = r.vehRepairRec.proofPicList;
					data.verrPayStatus = r.vehRepairRec.verrPayStatus;
					data.verrPayDate = r.vehRepairRec.verrPayDate;
					data.verrPayAccount = r.vehRepairRec.verrPayAccount;
					data.verrStatus=r.vehRepairRec.verrStatus;

				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			const dialogClosedHandle = () => {
				data.isEditRecord = false;
			};
			const closeModal = () => {
				data.isEditRecord = false;
			};
			const submit = async () => {
				if (data.verrVehId == "") {
					proxy.$message.error("请选择车辆");
					return;
				}
				if (data.verrTime == "") {
					proxy.$message.error("请填写维修日期");
					return;
				}
				if (data.verrTitle == "") {
					proxy.$message.error("请填写维修标题");
					return;
				}
				if (data.verrMoney == "") {
					proxy.$message.error("请填写维修金额");
					return;
				}
				if (data.verrDescribe == "") {
					proxy.$message.error("请填写维修描述");
					return;
				}

				let params = {
					verrId: data.verrId,
					verrVehId: data.verrVehId,
					verrType: data.verrType,
					verrTime: data.verrTime,
					verrTitle: data.verrTitle,
					verrMoney: data.verrMoney,
					verrHandler: data.verrHandler,
					verrDescribe: data.verrDescribe,
					verrRemark: data.verrRemark,
					proofPicList: data.proofPicList,
					verrPayStatus: data.verrPayStatus,
					verrPayDate: data.verrPayDate,
					verrPayAccount: data.verrPayAccount,
					verrStatus: data.verrStatus,
					itemList: [],
				}

				const r = await proxy.$http.post(apiObj.vehRepairRecupdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isEditRecord = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			//选择牵引车辆
			const getVehHeadList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.vehGetHeadList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.vehList;
				}
			};

			const getverrTime = (ev) => {
				data.verrTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.verrTime);
			};

			const getverrPayDate = (ev) => {
				data.verrPayDate = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.verrPayDate);
			};

			//删除图片
			const delImg = (index) => {
				let url = data.proofPicList[index];
				if (url.indexOf("https://") !== -1) {
					removeImgUrl(url);
				}
				data.proofPicList.splice(index, 1);
			};

			//上传图片
			const upLoadBase64uploadToOSS = async (imageUrl, type) => {
				await proxy.$http.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						data[type] = res;
					});
			};

			const uploadproofPicList = (file) => {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;
				if (isLt2M == false) {
					proxy.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (data.proofPicList.length >= 5) {
						proxy.$message.error("最多上传5张");
						return false;
					}
					proxy.$http
						.post("/api/ossUpload/base64Json", {
							name: imageUrl,
							value: "123",
						})
						.then((res) => {
							data.proofPicList.push(res);
						});
				});
			};

			//删除图片
			const removeImgUrl = async (imageUrl) => {
				await proxy.$http.post("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			};




			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getverrTime,
				getverrPayDate,
				uploadproofPicList,
				delImg,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}



	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 60px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 10px;
	}

	.platItemLeft {
		min-width: 90px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth2 {
		width: 100%;
		padding-left: 20px;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
		width: 60px;
		text-align: right;
	}

	.rpt_warp {
		width: 100%;
		background: #fff;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		border-bottom: 1px solid #eeeeee;
		text-align: left;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 42px;
	}

	.rpic_img_warp {
		margin-left: 42px;
	}

	.rpic_img_box {
		width: 100%;
		height: 150px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		margin-right: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.upRpic_icon_item {
		margin-top: 10px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.rpt_box3 {
		width: 100%;
		height: 286px;
		justify-content: space-between;
	}
</style>